<template>
  <RegionalManagerHome v-if="isRegionalManager" />
  <AdminBriefHome v-else-if="shouldShowAdminBrief" />
  <GeneralAnalytics v-else :store="selectedStore" />
</template>

<script>
import GeneralAnalytics from "@/components/analytics/GeneralAnalytics";
import RegionalManagerHome from "@/views/admin/analytics/RegionalManagerHome.vue";
import AdminBriefHome from "@/views/admin/analytics/AdminBriefHome.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    GeneralAnalytics,
    RegionalManagerHome,
    AdminBriefHome,
  },

  computed: {
    ...mapGetters("store", ["selectedStore"]),
    ...mapGetters("auth", ["accessibleStoreIds", "isRegionalManager", "shouldShowAdminBrief"]),
  },

  watch: {
    accessibleStoreIds: {
      immediate: true,
      handler(storeIds) {
        if (Array.isArray(storeIds) && storeIds.length > 0) {
          this.fetchBusinessVerticals({ storeId: [storeIds[0]], enabled: true });
        }
      },
    },
  },

  methods: {
    ...mapActions("businessVerticals", { fetchBusinessVerticals: "fetchIndex" }),
  },
};
</script>
